import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Calendar } from 'react-widgets';
import Localization from 'react-widgets/Localization';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
import classnames from 'classnames';

import { formatDate } from '../../helpers/timezone';
import { useOutsideClick } from '../../helpers/clickOutside';
import { ReactComponent as MenuButtonSVG } from '../../icons/table/menu-button.svg';
import { ReactComponent as QuestionMarkSVG } from '../../icons/question-mark.svg';

const local = {
  label: 'French',
  culture: 'fr',
  firstOfWeek: 1,
};

const TableCellDateSinglePick = ({
  label,
  date: d,
  onDateUpdate,
  readOnly,
}) => {
  const menuRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [date, setDate] = useState(d);

  useOutsideClick(menuRef, () => setShowDropdown(false));

  const classes = classnames('th-list-data', {
    pointer: !readOnly,
  });

  return (
    <div className={classes} id="th-cell-header" ref={menuRef}>
      <div
        className="flex items-center justify-between"
        onClick={readOnly ? () => {} : () => setShowDropdown(!showDropdown)}
      >
        <div>
          {label && <h3 className="ma0 pa0 th-members-list-name">{label}</h3>}
          {d ? (
            <p className="apps-card-app-desc">{formatDate(d)}</p>
          ) : (
            <p className="apps-card-app-desc">Not set</p>
          )}
        </div>
        {!readOnly && <MenuButtonSVG />}
      </div>

      {showDropdown && (
        <div
          className="th-select-filter-dropdown"
          style={{
            minWidth: '360px',
            width: document.getElementById('th-cell-header').offsetWidth,
            marginRight: '0',
            marginTop: '2px',
          }}
        >
          <div className="pr5 pl5 flex justify-between ">
            <div className="mt2 flex flex-column items-center">
              {label && (
                <h3 className="flex items-center pa0 th-members-list-name">
                  {label}
                  <QuestionMarkSVG data-rh="All time in the web app is in CET." />
                </h3>
              )}
              <Localization date={new DateLocalizer(local)}>
                <Calendar
                  bordered={false}
                  value={date}
                  onChange={(value) => setDate(value)}
                />
              </Localization>
            </div>
          </div>
          <div className="tc mb2 mt4">
            <button
              className="btn-whitegrey mr4"
              onClick={() => {
                onDateUpdate({ date: null });
                setShowDropdown(false);
              }}
            >
              <span>Reset</span>
            </button>
            <button
              className="btn-green"
              onClick={() => {
                onDateUpdate({ date });
                setShowDropdown(false);
              }}
            >
              <span>Update</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

TableCellDateSinglePick.propTypes = {
  date: PropTypes.instanceOf(Date),
  onDateUpdate: PropTypes.func.isRequired,
  label: PropTypes.string,
  readOnly: PropTypes.bool,
};

export default TableCellDateSinglePick;
